import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import store from "@/store"

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/login", // 访问 / 会自动跳转到 /login
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/home/:menuId',
    name: 'home',
    component: () => import('@/views/home/HomeLayout.vue'),
    meta: { requiresAuth: true }
  }, 
  {
    path: '/paper',
    name: 'paper',
    component: () => import('@/views/paper/PaperView.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: "add-question/:paperId", 
        name: "addPaperQuestion",
        component: () => import('@/views/paper/AddPaperQuestionView.vue')
      },
      {
        path: "get-questions/:paperId", 
        name: "paperQuestionView",
        component: () => import('@/views/paper/PaperQuestionView.vue')
      }
    ]
  },
  {
    path: "/exam",
    name: "examHome",
    component: () => import('@/views/exam/ExamView.vue'),
    meta: { requiresAuth: true },
    children: [   
      {
        path: "exam-list", 
        name: "examlist",
        component: () => import('@/views/exam/ExamSListView.vue')
      },      
      {
        path: ":examId", 
        name: "examId",
        component: () => import('@/views/exam/ExamHomeView.vue')
      },
      {
        path: ":examId/start/:userId", 
        name: "ExamContent",
        component: () => import('@/views/exam/ExamContentView.vue')
      },
      {
        path: ":examId/result/:userId", 
        name: "ExamResult",
        component: () => import('@/views/exam/ExamResultView.vue')
      },
      // 考试管理
      {
        path: "add-group", 
        name: "addGroup",
        component: () => import('@/views/exam/ExamAddGroupView.vue')
      },
      {
        path: "paper-management", 
        name: "ExamPaperManagement",
        component: () => import('@/views/paper/PaperManagementView.vue')
      },
      {
        path: "exam-management", 
        name: "ExamManagementView",
        component: () => import('@/views/exam/ExamManagementView.vue')
      },
      {
        path: "status", 
        name: "ExamStatus",
        component: () => import('@/views/exam/ExamStatusView.vue')
      }
    ]
  },
  {
    path: '/tiku',
    name: 'tiku',
    component: () => import('@/views/tiku/QuestionBankView.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: "bank-list", 
        name: "Banklist",
        component: () => import('@/views/tiku/QuestionBankManageView.vue')
      },
      {
        path: ":questionBankId/add-question-for-bank", 
        name: "addQuestionForBank",
        component: () => import('@/views/tiku/AddQuestionForBankView.vue')
      },
      {
        path: ":questionBankId/view-question-from-bank", 
        name: "viewQuestionFromBank",
        component: () => import('@/views/tiku/BankQuestionView.vue')
      },
      {
        path: ":questionBankId/select-question-from-bank", 
        name: "questionSectionView",
        component: () => import('@/views/tiku/QuestionSectionView.vue')
      },
      {
        path: ":questionBankId/practice-question-in-bank", 
        name: "bankQuestionPracticeView",
        component: () => import('@/views/tiku/BankQuestionPracticeView.vue')
      },
      {
        path: ":questionBankId/random-practice-from-bank", 
        name: "questionPracticeView",
        component: () => import('@/views/tiku/QuestionPracticeView.vue')
      },
      {
        path: ":questionBankId/simulation-practice-test/:randomId", 
        name: "SimulationExerciseView",
        component: () => import('@/views/tiku/SimulationExerciseView.vue')
      },
      {
        path: ":questionBankId/immediate-feedback/:randomId", 
        name: "ImmediateFeedbackView",
        component: () => import('@/views/tiku/ImmediateFeedbackView.vue')
      },
      
      {
        path: ":questionBankId/result/:userId", 
        name: "PracticeResult",
        component: () => import('@/views/tiku/QestionPracticeResultView.vue')
      },
    ]
  },
  {
    path: '/userInfo',
    name: 'userInfo',
    component: () => import('@/views/user/UserView.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: ":accountId/password-update", 
        name: "updatePassword",
        component: () => import('@/views/user/PasswordUpdateView.vue')
      },
      {
        path: ":accountId/userInfo-update", 
        name: "userInfoUpdate",
        component: () => import('@/views/user/UserInfoView.vue')
      }
    ]
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('my-app-store')

  // ✅ 如果是未登录并且要访问需要登录的页面，则跳转登录
  if (to.meta.requiresAuth && !token) {
    return next('/login')
  }

  // ✅ 如果已经登录且又访问登录页，直接跳首页
  if (to.path === '/login' && token) {
    return next('/home/homePage')
  }
  if (from.name === "ExamContent" && to.name !== "ExamResult") {
    // 离开考试页时，停止计时并清空状态
    store.dispatch("Exam/finishExam")
  }
  next()
})

export default router
